// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'normalize.css/normalize.css'
import VueI18n from 'vue-i18n'
import enLocale from 'vant/lib/locale/lang/en-US'
import zhLocale from 'vant/lib/locale/lang/zh-CN'
import axios from '@/utils/request'
import common from '@/utils/common'
import VueClipboard from 'vue-clipboard2'
import cookie from 'vue-cookie'
import { Image as VanImage } from 'vant'
import { Button,Tab,Tabs,Tabbar,TabbarItem,Field,Form,Toast,Checkbox,CheckboxGroup,NavBar,Tag,Locale,Picker,Popup,Cell,CellGroup,Dialog,DatetimePicker,Sidebar,SidebarItem,Switch,Col, Row,Sticky,Divider,Overlay, Empty,Icon} from 'vant'

Vue.use(Button)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Field)
Vue.use(Form)
Vue.use(Toast)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(NavBar)
Vue.use(VueI18n)
Vue.use(Tag)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Col);
Vue.use(Row);
Vue.use(Dialog)
Vue.use(DatetimePicker)
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Switch);
Vue.use(Sticky)
Vue.use(Divider);
Vue.use(cookie)
Vue.use(VueClipboard)
Vue.use(common)
Vue.use(Overlay);
Vue.use(VanImage);
Vue.use(Empty);
Vue.use(Icon);

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$downloadBaseUrl = process.env.NODE_ENV == 'production' ? 'http://wap.wiffa-coin.com' : 'http://cmh5.kws-info.com'

const messages = {
  en: {
    self: require('./lang/en'),
    ...enLocale
  },
  zh: {
    self: require('./lang/zh'),
    ...zhLocale
  }
}
const i18n = new VueI18n(
  {
    locale: localStorage.getItem('locale') || 'zh',
    messages
  }
)

router.beforeEach((to, from, next) => {
  // Redirect if fullPath begins with a hash (ignore hashes later in path)
  if (to.fullPath.substr(0,2) === "/#") {
      const path = to.fullPath.substr(2);
      console.log(path);
      next(path);
      return;
  }
  next();
});

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
})


